import { useEffect, useState } from 'react';
import { useClient } from '../context/ClientStatusContext';
import { ClientStatus } from '../model/ClientStatus';
import { fetchOrganizacie } from '../client/external/ciselniky/organizaciaClient';
import Organizacia from '../model/ciselniky/Organizacia';
import { OrganizaciaFilterSearch } from '../model/OrganizaciaFilterSearch';

interface ReturnType {
  organizacie: Organizacia[];
  organizacieStatus: ClientStatus;
}

export default (
  searchParams: OrganizaciaFilterSearch,
): ReturnType => {
  const {
    nazov,
    legislativna,
    platna,
    limit,
    ldap,
    typ,
    ids,
  } = searchParams;
  const [, setAction] = useState(0);
  const {
    wrapClient,
    data,
    status,
  } = useClient(fetchOrganizacie);

  useEffect(() => {
    setAction(prevState => {
      clearTimeout(prevState);
      return prevState;
    });

    const act = setTimeout(async () => {
      await wrapClient(typ, ids, ldap, nazov, legislativna, platna, limit);
    }, 300);

    // @ts-ignore
    setAction(act);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nazov, limit]);

  return {
    organizacie: data || [],
    organizacieStatus: status,
  };
};
